import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as staffAndRoomActions from 'features/staff-and-rooms/duck';
import * as userActions from 'core/duck';
import { AlertMessage } from 'shared/components';
import { INVITATION_STATUS as invStatus, REQUEST_UPDATE_STATUS } from 'shared/constants';
import DashboardInvitationCard from './DashboardInvitationCard';
import './DashboardInvitation.scss';

class DashboardInvitation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showMessage: false,
      alertMessage: '',
      isError: false,
    };

    this.removeMessage = this.removeMessage.bind(this);
  }

  componentDidMount() {
    if (!this.props.staffInvitations.length) {
      this.props.actions.getStaffInvitations();
    }
    if (!this.props.testCenterInvitations.length) {
      this.props.actions.getTestCenterInvitations();
    }
  }

  updateInvitationStatus = (id, newStatus, invitationType) => {
    const updateInvitationType = invitationType === 'staff' ? 'updateStaffInvitation' : 'updateTestCenterInvitation';
    const getInvitation = invitationType === 'staff' ? 'getStaffInvitations' : 'getTestCenterInvitations';
    this.setState({
      isError: false,
      showMessage: false,
    });
    this.props.actions[updateInvitationType](id, newStatus)
      .then(() => {
        if (!this.props.error) {
          this.setState({
            isError: false,
            showMessage: true,
            showMessageTime: 3000,
            alertMessage: 'dashboard.alertUserNotified',
          });
          if (newStatus === invStatus.accept && invitationType === 'staff') {
            this.props.actions.getTestCenterPersonnel(this.props.currentUser.id);
          }
        } else {
          this.setState({
            isError: true,
            showMessage: true,
            showMessageTime: 3000,
            alertMessage: 'errors.somethingWentWrong',
          });
        }
        this.props.actions[getInvitation]();
      });
  };

  removeMessage() {
    this.setState({
      showMessage: false,
    });
  }

  render() {
    const {
      staffInvitations,
      testCenterInvitations,
    } = this.props;
    const {
      showMessage,
      alertMessage,
      showMessageTime,
    } = this.state;

    return (
      <div>
        {Boolean(staffInvitations.length) && (
          <section>
            {staffInvitations.map((invitation, idx) => invitation.status === REQUEST_UPDATE_STATUS.pending && (
              <DashboardInvitationCard
                key={`invite-${idx}`}
                name={invitation.testCenterEvent.testCenterCycle.testCenterProgram.testCenter.name}
                date={invitation.testCenterEvent.testingEvent.name}
                id={invitation.id}
                invitation={invitation}
                updateStatus={this.updateInvitationStatus}
                invitationType="staff"
              />
            ))}
          </section>
        )}
        {Boolean(testCenterInvitations.length) && (
          <section>
            {testCenterInvitations.map((invitation,idx) => invitation.status === 'pending' && (
              <DashboardInvitationCard
                key={`invite-card-${idx}`}
                name={invitation.testCenter.name}
                id={invitation.id}
                invitation={invitation}
                updateStatus={this.updateInvitationStatus}
                invitationType="testCenter"
              />
            ))}
          </section>
        )}
        <AlertMessage
          show={showMessage}
          time={showMessageTime}
          isError={this.state.isError}
          removeMessage={this.removeMessage}
          message={alertMessage}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    staffInvitations: state.staff.staffInvitations || [],
    testCenterInvitations: state.staff.testCenterInvitations || [],
    error: state.staff.error,
    loading: state.staff.loading,
  };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators({ ...userActions, ...staffAndRoomActions }, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardInvitation);

DashboardInvitation.propTypes = {
  staffInvitations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  testCenterInvitations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  error: PropTypes.string.isRequired,
  actions: PropTypes.shape({
    getStaffInvitations: PropTypes.func.isRequired,
    getTestCenterInvitations: PropTypes.func.isRequired,
    updateStaffInvitation: PropTypes.func.isRequired,
    updateTestCenterInvitation: PropTypes.func.isRequired,
    getUserProfile: PropTypes.func.isRequired,
  }).isRequired,
};
